/* New footer sections start closed. Native disclosures own every later user choice. */
(() => {
  if (window.saberFooterInitialized) return;
  window.saberFooterInitialized = true;
  const initialized = new WeakSet();
  function initialize(root = document) {
    const groups = [...root.querySelectorAll("saber-footer-nav")];
    if (root.matches?.("saber-footer-nav")) groups.unshift(root);
    groups.forEach((navigation) => {
      if (initialized.has(navigation)) return;
      navigation.querySelectorAll(".ss-foot-group").forEach((panel) => {
        panel.open = false;
      });
      initialized.add(navigation);
    });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => initialize(), {
      once: true,
    });
  else initialize();
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
})();
